<template>
    <svg class="isc-svg-icon" xmlns="http://www.w3.org/2000/svg" :style="style" :class="{ rotating: !!rotating }">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="href" />
    </svg>
</template>

<script>
export default {
    name: 'IscSvgIcon',

    props: {
        name: {
            type: String,
            default: undefined
        },

        size: {
            type: String,
            default: '16px'
        },

        color: {
            type: String,
            default: 'inheirt'
        },

        rotate: {
            type: [Number, String],
            default: 0
        },

        rotating: {
            type: [Number, String],
            default: 0
        }
    },

    computed: {
        href() {
            return '#' + this.name;
        },

        style() {
            const { size, color, rotate, rotating } = this;
            return {
                color,
                width: size,
                height: size,
                transform: `rotate(${rotate}deg)`,
                animationDuration: rotating ? `${rotating}s` : ''
            };
        }
    }
};
</script>

<style scoped>
@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.isc-svg-icon {
    fill: currentColor;
    flex-grow: 0;
    flex-shrink: 0;
    transition: color 0.3s;
}
.isc-svg-icon.rotating {
    animation: rotating 2s infinite linear;
}
</style>
